import { render, staticRenderFns } from "./TrainCard.vue?vue&type=template&id=2618bc7e"
import script from "./TrainCard.vue?vue&type=script&lang=js"
export * from "./TrainCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports